import { render } from "./BaseSelect.vue?vue&type=template&id=cd82279a&scoped=true"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=cd82279a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd82279a"]])

export default __exports__